import {Anchor, Group, Paper, Stack, Table, Title} from '@mantine/core'
import {IconDownload} from '@tabler/icons-react'

import type {DriverJob} from './schemas'

type DriverJobDocumentsSectionProps = {
    job: DriverJob
    accessToken: string
}

function formatBytes(bytes: number): string {
    if (bytes === 0) return '0 Bytes'
    const k = 1024
    const sizes = ['Bytes', 'KB', 'MB', 'GB']
    const i = Math.floor(Math.log(bytes) / Math.log(k))
    return Math.round((bytes / Math.pow(k, i)) * 100) / 100 + ' ' + sizes[i]
}

export function DriverJobDocumentsSection({job, accessToken}: DriverJobDocumentsSectionProps) {
    if (job.documents.length === 0) {
        return null
    }

    return (
        <Paper withBorder p="md" radius="md">
            <Stack gap="md">
                <Title order={3}>Documents</Title>
                <Table>
                    <Table.Thead>
                        <Table.Tr>
                            <Table.Th>Name</Table.Th>
                            <Table.Th>Type</Table.Th>
                            <Table.Th>Size</Table.Th>
                            <Table.Th>Actions</Table.Th>
                        </Table.Tr>
                    </Table.Thead>
                    <Table.Tbody>
                        {job.documents.map((document) => (
                            <Table.Tr key={document.id}>
                                <Table.Td>{document.name}</Table.Td>
                                <Table.Td>{document.contentType}</Table.Td>
                                <Table.Td>{formatBytes(document.sizeBytes)}</Table.Td>
                                <Table.Td>
                                    <Anchor
                                        href={`/api/driver/jobs/${job.id}/documents/${document.id}/content?access=${accessToken}`}
                                        download
                                        size="sm"
                                    >
                                        <Group gap="xs" style={{display: 'inline-flex'}}>
                                            <IconDownload size={16} />
                                            Download
                                        </Group>
                                    </Anchor>
                                </Table.Td>
                            </Table.Tr>
                        ))}
                    </Table.Tbody>
                </Table>
            </Stack>
        </Paper>
    )
}
